export default __webpack_public_path__ + "/dist/images/6724585.png";